
            const data = {"name":"more","data":{"width":"12","height":"12","viewBox":"0 0 12 12","data":"<path pid=\"0\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"m5.006 5 .001-.44L5 4.53V0h2v5h5v2H7.457L7 6.999V12H5V7.457l.001-.463h-.44L4.531 7H.001V5h5.005Z\" _fill=\"#343434\"/>","originalColors":[{"type":"fill","color":"#343434"}],"stopColors":[]}}
        
                    module.exports = data
                    